import React from 'react';
import ReactDOM from 'react-dom';
import { getBackgroundImageURL, getLayout } from '../../lib/ep';

const Wrapper = (props) => {
	const is_builder = props?.is_builder ?? false;
	const is_preview_templates = props?.is_preview_templates ?? false;

	if(!is_builder || is_preview_templates) {
		return props.children;
	}

	let element = document.getElementById('promo_bg_builder');
	if(element == undefined) {
		if(document.querySelector('.gui_preview_contents_c') != undefined) {
			element = document.createElement('div');
			element.id = 'promo_bg_builder';
			document.querySelector('.gui_preview_contents_c').appendChild(element);
			element = document.getElementById('promo_bg_builder');
		} else {
			// If the element .gui_preview_contents_c doesn't exist in the DOM,
			// we simply return the background as it would be in production.
			// It may cause some scrolling background issues as it will not be fixed
			// and will scroll up altogether the promotion contents, but at least
			// it won't break up the page with a "Non existing element" error.
			return props.children;
		}
	}

	return ReactDOM.createPortal(
		<>
			{props.children}
		</>,
		element,
	);
};

const BackgroundImage = (props) => {
	let promotion = false;
	if(props.promotion != undefined) promotion = {...props.promotion};

	if(promotion === false) return null;
	
	promotion.layout_props = props?.layout_props ?? getLayout(promotion);
	
	const bg_settings = getBackgroundImageURL(promotion);

	const force_bg_image = props?.force_bg_image ?? false;

	let bg_image_url = (force_bg_image !== false) ? force_bg_image : (bg_settings?.url ?? false);
	if(bg_image_url !== false && (bg_image_url.indexOf('undefined') !== -1 || bg_image_url.indexOf('custom') !== -1)) bg_image_url = false;

	const bg_color_as_ink = bg_settings?.is_preset ?? false;

	const classes = ['promo_bg'];
	if(bg_color_as_ink) classes.push('bg_color_as_ink');

	const image_urls = [];
	const image_widths = [];
	if(bg_image_url !== false) {
		classes.push("with_bg_image");

		if((promotion.layout_props?.background?.background_image_mobile ?? false) !== false) {
			image_urls.push(promotion.layout_props.background.full_background_image_mobile);
			image_widths.push(800);
		}

		image_urls.push(bg_image_url);
		image_widths.push(900);
	}

	const src_set = [];
	image_urls.map((image) => {
		src_set.push(`${image}`);
	});

	const image_sizes = [];
	image_widths.map((width, w) => {
		if(w < image_widths.length - 1) {
			//image_sizes.push(`max-width:${width}px`);
			image_sizes.push(`orientation:portrait`);
		} else {
			//image_sizes.push(`min-width:${width}px`);
			image_sizes.push(`orientation:landscape`);
		}
	});

	return (
		<Wrapper
			is_builder={props.is_builder}
			is_preview_templates={props.is_preview_templates}
		>
			<aside class={classes.join(" ")} aria-label='background'>
				{(image_urls.length > 0) && (
					<picture>
						{image_urls.map((image, i) => {
							return (
								<source
									key={`bg_source_${i}`}
									media={`(${image_sizes[i]})`}
									srcSet={image}
								/>
							)
						})}

						<img src={src_set[src_set.length - 1]} alt="" />
					</picture>
				)}
			</aside>
		</Wrapper>
	)
};

export default BackgroundImage;